enum CursorType {
  MOVE = 'move',
  HORIZONTAL_MOVE = 'horizontalMove',
  VERTICAL_MOVE = 'verticalMove',
}

export default CursorType;
